import { createTheme } from "@mui/material/styles";
import { focusFirstField } from "utils/focusHelper";

const theme = createTheme({
  palette: {
    background: {
      default: "#ffffff", // Change to your desired background color 
      paper: "#ffffff", // Change if needed
      darkBackground: '#000000'
    },
    text: {
      primary: "#000000", // Change to white ("#ffffff") if using a dark background
      secondary: "#757575",
      label: "#374151",
      grayText:'#4B5563',
      white: '#ffffff'
    },
    primary: {
      main: "#000000", // Update primary color
    },
    secondary: {
      main: "#ffffff", // Update secondary color
    },
    lightgray:{
      main: '#f4f6f9'
    },
    red:{
      main: '#c31f1f'
    },
    drawermenuitem: {
        main: '#4D4D4D',
    },
    typographyLabel:{
      main: '#000000'
    },
    lightgrey: {
        main: "#A1A1A1"
    },
    highlight: {
        main: "#29ae00", 
    },
  },
  // fontFamily: 'Roboto, Arial, sans-serif',
  fontFamily: "system-ui",
  typography: {
    // fontFamily: 'Roboto, Arial, sans-serif',
    fontFamily: "system-ui",
    h5: {
      fontSize: '1.5rem',
      fontWeight: 500,
    },
    h6: {
      fontSize: '1.25rem',
      fontWeight: 400,
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.5,
    },
    body2: {
      fontSize: '0.875rem'
    },
    subtitle1: {
      fontSize: '0.875rem',
    },
    subtitle2: {
      fontSize: '0.75rem',
    },
    span: {
      fontSize: '0.75rem'
    },
    p: {
      fontSize: '0.875rem'
    }
  },
  formFileds: {
    borderRadius: '6px',
    height: '45px'
  },
  components: {
    MuiDialog: {
      defaultProps: {
        TransitionProps: {
          onEntered: (node) => {
            focusFirstField(node);
          },
        },
      },
    },
  },
});

export default theme;
